import { Box, DownloadButtons, Typography, Button, Grid, Stack } from 'src/components';

const CallToActionHero = ({
  title,
  description,
  video
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        height: '100%', 
        overflow: 'hidden'
      }}
    >
        <Grid container alignItems="center" height="100%" columns={2}>
          {/* Left: GIF/Image */}
          <Grid size={1} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              component="video"
              src={video}
              autoPlay
              muted
              loop
              playsInline
              alt={"PanAm Explorer Feature"}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </Grid>

          {/* Right: Content */}
          <Grid size={1} sx={{ p: 10, height: '100%' }}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '3rem' },
                mb: 2,
              }}
            >
              {title}
            </Typography>

            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ mb: 1, maxWidth: '500px' }}
            >
              {description}
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
              <DownloadButtons displayInlineOnMobile={true} />
            </Box>

          </Grid>
        </Grid>
    </Box>
  );
};

export default CallToActionHero;
